export default "__VITE_ASSET__B0o0Gic3__"